import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
  ModalButtons,
  Typography,
  Button,
} from 'pvs-design-system';

interface DeleteParameterModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteParameterModal: React.FC<DeleteParameterModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal onClose={onClose} open={isOpen} closeModalOnBackdropClick>
      <ModalHeader title="Delete Parameter?" onClose={onClose} description="" />
      <ModalContent>
        <Typography variant="p-sm">
          Deleting this custom parameter may cause links that reference this
          tool to fail. This action cannot be undone.
        </Typography>
      </ModalContent>
      <ModalFooter>
        <ModalButtons>
          <Button id="modalCancel" color="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button id="modalDeleteParameter" color="warning" onClick={onConfirm}>
            Yes, delete parameter
          </Button>
        </ModalButtons>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteParameterModal;
